import {
  IIsoRowPattern,
  IIsoTierPattern,
} from "open-vessel-definition/build/src/models/base/types/IPositionPatterns";

import { ISlotData } from "open-vessel-definition";
import { ISlotPattern } from "../types/IPositionPatterns";
import TContainerLengths from "../TContainerLengths";

export class SmartSlotData {
  data: ISlotData;
  private _row: IIsoRowPattern;
  private _tier: IIsoTierPattern;

  constructor(data: ISlotData) {
    this.data = data;
    this._row = data.pos.substring(0, 2) as IIsoRowPattern;
    this._tier = data.pos.substring(2) as IIsoTierPattern;
  }

  get pos(): ISlotPattern {
    return this.data.pos;
  }

  get row(): IIsoRowPattern {
    return this._row;
  }

  get tier(): IIsoTierPattern {
    return this._tier;
  }

  get allSizes(): TContainerLengths[] {
    const sizes = this.data.sizes || {};

    return (Object.keys(sizes).map(Number) as TContainerLengths[]).filter(
      (size) => sizes[size] !== 0 && sizes[size] !== undefined,
    );
  }

  get maxSize(): TContainerLengths | undefined {
    const allSizes = this.allSizes;
    if (allSizes.length === 0) {
      return undefined;
    }

    return Math.max(...this.allSizes) as TContainerLengths;
  }

  get hasNoSizes(): boolean {
    return this.allSizes.length === 0;
  }

  get has20s(): boolean {
    return this.allSizes.some((size) => size < 40);
  }

  get has40s(): boolean {
    return this.allSizes.some((size) => size >= 40);
  }

  get isRestricted(): boolean {
    return !!this.data.restricted;
  }
}
